<template>

</template>

<script>
export default {
  name: "SalesRankings"
}
</script>

<style scoped>

</style>


// WEBPACK FOOTER //
// SalesRankings.vue?f2a66ab6